import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function FormDialog(props) {
  

  return (
    <div>
      <Dialog fullWidth={true} maxWidth={props.size ? props.size : 'lg'} open={props.open} onClose={props.handleClose}>
        <DialogTitle>{props.title && props.title}</DialogTitle>
        <DialogContent>

          {props.form}
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}